import React, { useState } from 'react';
import { Cog6ToothIcon, XMarkIcon } from '@heroicons/react/24/outline';

const apps = [
  { name: 'DECLASS', port: 3000, description: 'Defense Intelligence' },
  { name: 'Legal', port: 3001, description: 'Legal eDiscovery' },
  { name: 'Health', port: 3002, description: 'Healthcare Compliance' },
  { name: 'YourFabric', port: 3003, description: 'Custom Classification' },
  { name: 'Admin', port: 3004, description: 'Control Center' },
  { name: 'ZoomFabric', port: 3006, description: 'Call Intelligence' },
  { name: 'Election', port: 3008, description: 'Voter Intelligence', current: true }
];

export default function AdminNavigator() {
  const [isOpen, setIsOpen] = useState(false);

  const navigateToApp = (port) => {
    const baseUrl = window.location.hostname;
    window.open(`http://${baseUrl}:${port}`, '_blank');
  };

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-4 right-4 p-3 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-colors z-50"
        title="Navigate to other apps"
      >
        <Cog6ToothIcon className="h-6 w-6" />
      </button>

      {/* Slide-out panel */}
      {isOpen && (
        <div className="fixed inset-0 z-50">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black bg-opacity-25"
            onClick={() => setIsOpen(false)}
          />

          {/* Panel */}
          <div className="absolute right-0 top-0 h-full w-80 bg-white shadow-xl">
            <div className="p-4 border-b flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-900">Cognitive Fabric Apps</h2>
              <button
                onClick={() => setIsOpen(false)}
                className="p-1 rounded-md hover:bg-gray-100"
              >
                <XMarkIcon className="h-5 w-5 text-gray-500" />
              </button>
            </div>

            <div className="p-4 space-y-2">
              {apps.map((app) => (
                <button
                  key={app.name}
                  onClick={() => !app.current && navigateToApp(app.port)}
                  disabled={app.current}
                  className={`w-full text-left p-3 rounded-lg transition-colors ${app.current
                      ? 'bg-blue-50 border-2 border-blue-200 cursor-default'
                      : 'hover:bg-gray-50 border border-gray-200'
                    }`}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-medium text-gray-900">{app.name}</div>
                      <div className="text-sm text-gray-500">{app.description}</div>
                    </div>
                    {app.current && (
                      <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                        Current
                      </span>
                    )}
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
